import { useContext, useEffect, useRef } from "react";
import { Form } from "react-bootstrap";
import { FormContext } from "../../contexts/FormContext";
import Helper from "../../util/helper";
import './Choice.css';
import { RenderScrollContext } from "../../contexts/RenderScrollContext";

export const Choice = ({ name, label, choiceIndex, parentData, onUpdateValue, isAdvancedForm, position, isDisabled, isHorizontal }) => {
  const { isHTML, getScreenDimensions } = useContext(FormContext);
  const { calculateWidthPercentageOfPage, getPageWidth, getPageHeight } = useContext(RenderScrollContext);

  const advancedChoiceRef = useRef(null);

  const checkComponentSize = () => {
    if (!isAdvancedForm) return;

    const { width } = advancedChoiceRef.current.getBoundingClientRect();
    const { height } = advancedChoiceRef.current.getBoundingClientRect();

    const { page } = position;
    const percentage = calculateWidthPercentageOfPage(page - 1);

    const scaledWidth = width * (percentage / 100);
    const scaledHeight = height * (percentage / 100);

    advancedChoiceRef.current.style.setProperty("width", `${scaledWidth}px`);
    advancedChoiceRef.current.style.setProperty("height", `${scaledHeight}px`);
    advancedChoiceRef.current.style.setProperty("min-width", `${scaledWidth}px`);
    advancedChoiceRef.current.style.setProperty("font-family", `${getPositionStyles().fontFamily}`);
  }
  
  const hideBorders = isAdvancedForm && parentData.hideborders;
  const handleChange = () => {
    onUpdateValue(choiceIndex);
  };

  const getPositionStyles = () => {
    const { fontFamily, fontSize } = getScreenDimensions();

    const { posx, posy, sizex, page } = position;
    const percentage = calculateWidthPercentageOfPage(page - 1);

    const pageWidth = getPageWidth(page - 1);
    const pageHeight = getPageHeight(page - 1);
    return Helper.getElementPositionStyles(posx, posy, sizex, fontFamily, '', pageWidth, pageHeight, percentage, isHorizontal, fontSize);
  }

  useEffect(() => {
    if (isDisabled) {
      onUpdateValue(null)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDisabled])

  useEffect(() => {
    checkComponentSize();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return isHTML ? (
    <div className="radiobutton-html-container" style={isAdvancedForm ? getPositionStyles() : {}}>
      <Form.Check ref={advancedChoiceRef} className={`${hideBorders ? 'hide-radiobutton-borders' : ''}`} type="radio" id={label} name={name} onChange={handleChange} checked={parentData.selectedchoice === choiceIndex} label={<div dangerouslySetInnerHTML={Helper.mapInnerHtmlData(label)} />} disabled={isDisabled} />
    </div>
  ) : (
    <Form.Check style={isAdvancedForm ? getPositionStyles() : {}}
      ref={advancedChoiceRef}
      className={`${hideBorders ? 'hide-radiobutton-borders' : ''} ${isAdvancedForm ? 'advanced-form' : ''}`}
      type="radio"
      id={label}
      name={name}
      label={label}
      onChange={handleChange}
      checked={isAdvancedForm ? undefined : parentData.selectedchoice === choiceIndex}
      disabled={isDisabled}
    />
  );
};
